import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import {
  Button,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Pagination,
  Stack,
} from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import { getWearNatureData } from "_controllers/officer";
import dotenv from "dotenv";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import authAxios from "setups/axios";
import { AddWearNatureModal, EditWearNatureModal, DeleteConfirmationModel } from "utils/helperComponent";
import { formateData } from "utils/helper";

dotenv.config();

const Main = () => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [editItem, setEditItem] = useState("");
  const [addItem, setAddItem] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [wearNatureData, setWearNatureData] = useState([]);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");

  const itemsPerPage = 10; // Adjust this based on your preference
  const totalPages = Math.ceil(wearNatureData.length / itemsPerPage);
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = wearNatureData.slice(indexOfFirstItem, indexOfLastItem);

  // Initialization state
  const fetchData = async () => {
    try {
      const response = await getWearNatureData();
      setWearNatureData(response.data);
      setLoading(false);
    } catch (error) {
      setMessage(error?.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const confirmDelete = async (id) => {
    const response = await authAxios()({
      url: `/api/v1/admin/dash/wear-nature/${id}`,
      method: "DELETE",
    });
    toastMessage(response.data.message, "success");
    setMessage(response?.data.message);
    const updatedData = wearNatureData.filter((item) => item._id !== id);
    setWearNatureData(updatedData);
  };
  const handleDelete = async (id) => {
    setDeleteDialogOpen(true);
    setDeletedItemId(id);
  };
  const onEditSave = async (inputData, id) => {
    try {
      setLoading(true);
      const response = await authAxios()({
        url: `/api/v1/admin/dash/wear-nature/${id}`,
        method: "PUT",
        data: inputData,
      });
      toastMessage(response.data.message, "success");
      setMessage(response?.data.message);
      setWearNatureData((prevData) => {
        return prevData.map((item) => {
          if (item._id === id) {
            const { updatedAt } = response.data.data;
            inputData.updatedAt = updatedAt;
            return { ...item, ...inputData };
          }
          return item;
        });
      });
      setLoading(false);
    } catch (error) {
      setMessage(error?.message);
    }
  };
  const onAddSave = async (inputData) => {
    try {
      setLoading(true);
      const response = await authAxios()({
        url: `/api/v1/admin/dash/wear-nature`,
        method: "POST",
        data: inputData,
      });
      console.log("🚀 ~ file: WearNature.jsx:110 ~ response:", response.data);
      toastMessage(response.data.message, "success");
      setMessage(response?.data.message);
      const { createdAt, updatedAt } = response.data.data;
      inputData.createdAt = createdAt;
      inputData.updatedAt = updatedAt;
      setWearNatureData((prevData) => [inputData, ...prevData]);
      setLoading(false);
    } catch (error) {
      setMessage(error?.message);
    }
  };
  const handleCloseDialog = () => {
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };
  const onClose = () => {
    setIsEditModalOpen(false);
    setIsAddModalOpen(false);
    return;
  };

  return (
    <>
      <Box
        style={{
          padding: "0px 10px",
          border: "1px solid #eaeaea",
          borderRadius: "10px",
          // boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
          marginRight: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}>
        <Grid>
          <p style={{ fontWeight: "bolder", fontSize: "1.25rem" }}>Wear Nature List</p>
        </Grid>
        <Button
          variant="contained"
          sx={{ height: "50%", margin: "14px 25px 0px 0px" }}
          onClick={() => {
            setAddItem(addItem);
            setIsAddModalOpen(true);
          }}>
          Add new
        </Button>
      </Box>

      <Box
        style={{
          marginRight: "20px",
        }}>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            {isEditModalOpen ? (
              <EditWearNatureModal
                editItem={editItem}
                onSave={onEditSave}
                onClose={onClose}
              />
            ) : (
              ""
            )}
            {isAddModalOpen ? (
              <AddWearNatureModal
                addItem={addItem}
                onSave={onAddSave}
                onClose={onClose}
              />
            ) : (
              ""
            )}
            {isDeleteDialogOpen ? (
              <DeleteConfirmationModel
                onOpen={isDeleteDialogOpen}
                onClose={handleCloseDialog}
                confirmDelete={confirmDelete}
                deletedItemId={deletedItemId}
              />
            ) : (
              ""
            )}
            <TableContainer
              component={Paper}
              sx={{ mt: 1 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ fontWeight: "bolder" }}>
                      Name
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ fontWeight: "bolder" }}>
                      Description
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bolder" }}>
                      Created At
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bolder" }}>
                      Updated At
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: "bolder" }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItems && currentItems?.length > 0 ? (
                    currentItems?.map((item) => (
                      <TableRow key={item._id}>
                        <TableCell align="left">{item?.name}</TableCell>
                        <TableCell align="left">{item?.description}</TableCell>
                        <TableCell align="center">{formateData(item.createdAt)}</TableCell>
                        <TableCell align="center">{formateData(item.updatedAt)}</TableCell>
                        <TableCell
                          align="center"
                          style={{ display: "flex", justifyContent: "space-evenly" }}>
                          <EditIcon
                            sx={{
                              cursor: "pointer",
                              color: "green",
                            }}
                            onClick={() => {
                              setEditItem(item);
                              setIsEditModalOpen(true);
                            }}
                          />
                          {deleteLoading ? (
                            <CircularProgress />
                          ) : (
                            <DeleteIcon
                              sx={{
                                cursor: "pointer",
                                color: "red",
                              }}
                              onClick={() => handleDelete(item._id)}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <Box sx={{ textAlign: "left", pt: 1 }}>
                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}>
                        No Wear Nature Available.
                      </Typography>
                    </Box>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Grid
              justifyContent={"center"}
              container
              p={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </Grid>
          </>
        )}
      </Box>
    </>
  );
};

const WearNature = () => {
  return (
    <AccessController roles={["ADMIN"]}>
      <DashGridL2
        Top={TopBar}
        Main={Main}
      />
      <Toaster />
    </AccessController>
  );
};

export default WearNature;
